export default "__VITE_ASSET__BflSVpLW__"